var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pt-5 pb-15 px-5 d-flex flex-column align-center justify-start gap-14 h-full"
  }, [_vm.fullscreen ? _c('v-btn', {
    staticClass: "close-preview",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closePreview
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-close")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex flex-column align-center gap-14"
  }, [_c('div', {
    staticClass: "preview-title"
  }, [_vm._v(_vm._s(_vm.$t('auth_preview_title')))]), _c('v-select', {
    attrs: {
      "items": _vm.screenPreviewOptions,
      "item-text": "name",
      "item-value": "value",
      "label": _vm.$t('auth_preview_select_option'),
      "solo": ""
    },
    model: {
      value: _vm.screenPreview,
      callback: function callback($$v) {
        _vm.screenPreview = $$v;
      },
      expression: "screenPreview"
    }
  })], 1), _c('div', {
    staticClass: "phone-ctn",
    class: {
      'fullscreen': _vm.fullscreen
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/iphone-frame.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "phone-content"
  }, [_c('PreviewScreen', _vm._b({
    attrs: {
      "id": "screen-preview"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(branding) {
        return [_c(_vm.screenPreview === 'splash' ? 'SplashingScreen' : 'ScanningScreen', _vm._b({
          tag: "component"
        }, 'component', branding, false))];
      }
    }])
  }, 'PreviewScreen', _vm.getAppBrandingTheme, false))], 1)]), _c('div', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('auth_preview_hint')))])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }